import { Either } from 'src/utils/either';
import { endpoints } from 'src/utils/axios';

import { httpResponseHandler } from 'src/http/http-response-handler';

import {
  HttpTypes,
  BadRequestError,
  ConnectionError,
  UnexpectedError,
  AccessDeniedError,
  InternalServerError,
  TooManyRequestsError,
} from '../../http';

export class MissionsRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async getMissionsList(
    params?: any
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.missions.list,
      params,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getMissionDetails(
    id: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.missions.details(id),
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getCustomScanDetails(
    id: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.missions.details(id),
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getCustomScanV2Details(
    id: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.missions.details(id),
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getCustomScanV3Details(
    id: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.missions.details(id),
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getCustomScanV2Progress(
    id: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.missions.customScanProgress(id),
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getCustomScanV3Progress(
    id: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.missions.customScanProgress(id),
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getCustomScanProgress(
    id: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.missions.customScanProgress(id),
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async startQuiz(body: {
    missionId: string;
  }): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.missions.startQuiz,
      body,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async finishQuiz(body: {
    missionId: string;
    answers: string[];
  }): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: endpoints.missions.finishQuiz,
      body,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async checkIn(body: {
    missionId: string;
    location: number[];
  }): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: endpoints.missions.checkIn,
      body,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async startScanMission(body: {
    missionId: string;
  }): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.missions.startQuiz,
      body,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async startCustomScanMission(body: {
    missionId: string;
  }): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.missions.startQuiz,
      body,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getCarPlateDetails(
    id: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.missions.details(id),
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async startCarPlateMission(body: {
    missionId: string;
  }): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.missions.startQuiz,
      body,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async registerCarPlate(body: {
    missionId: string;
    carPlate: string[];
  }): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: endpoints.missions.registerCarPlate,
      body,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async finishInstant(body: {
    missionId: string;
  }): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: endpoints.missions.finishInstant,
      body,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async startCustomScanV2Mission(body: {
    missionId: string;
  }): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.missions.startQuiz,
      body,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }
}
